<template>
  <transition name="fade">
    <div class="blackPopupMsg" v-show="isShow" :style="dataStyle">{{msgData}}</div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isShow: false,
      msgData: "",
      dataStyle: {}
    };
  },
  computed: {
    ...mapGetters([
      "SpriteOperation",
      "BgOperation"
    ])
  },
  watch: {
    SpriteOperation: {
      handler(val) {
        if (val == "add") {
          this.isShow = false;
        }
      }
    },
    BgOperation: {
      handler(val) {
        if (val == "add") {
          this.isShow = false;
        } else {
          this.isShow = true;
          this.msgData = "请选择左侧的素材进行替换";
        }
      }
    }
  },
  mounted() {
    this.$bus.on("blackPopupMsg_showTips", data => {
      this.msgData = data.text;
      this.isShow = true;
      this.dataStyle = data.position;
    });
    this.$bus.on("window_click", data => {
      this.isShow = false;
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.blackPopupMsg {
  position: fixed;
  top: 50%;
  left: 388px;
  margin-top: -38px;
  width: 160px;
  height: 77px;
  padding: 17px 32px;
  opacity: 1;
  background-color: rgba(7, 6, 6, 0.65);
  z-index: 99;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;

  &:before {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: -20px;
    margin: auto 0;
    content: "";
    width: 0;
    height: 0;
    border-width: 8px 10px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0) rgba(0, 0, 0, 0.65) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
  }
}
.fade-enter-to,
.fade-leave-active {
  transition: all .6s ease;
}
.fade-leave-active {
  transition: all .6s ease;
}
.fade-enter-to,.fade-leave-from {
  transform: translate(0,0);
}
.fade-enter-from,
.fade-leave-to {
  transform: translate(-10px,0);
}
</style>



// WEBPACK FOOTER //
// src/components/Popups-z/blackPopupMsg.vue